import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCAp-FtyU3tiZuJsFd7bumDa1Muj7lpPZc",
  authDomain: "saaol-erp.firebaseapp.com",
  projectId: "saaol-erp",
  storageBucket: "saaol-erp.firebasestorage.app",
  messagingSenderId: "773434276792",
  appId: "1:773434276792:web:43037040fc5b4f35e76d4d",
  measurementId: "G-BG455KLG2M"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
